import React from 'react';
import MIG_Quote_Tool from './MIG_Quote_Tool';

function App() {
  return <MIG_Quote_Tool />;
}

export default App;